<template>
    <layout-admin>

        <div class="mt-3" slot="sidebar">

            <form-login></form-login>

        </div>

    </layout-admin>
</template>

<script>
    import AuthLayout from "../layouts/AuthLayout";

    import LayoutAdmin from "../layouts/LayoutAdmin";
    import FormLogin from "../forms/FormLogin";

    export default {
        components: {FormLogin, LayoutAdmin, AuthLayout},data: function () {
            return {
            }
        },
        metaInfo: {
            title: 'ورود',
        },
        created: function () {
            //console.log('created page')
        },

        name: "PageLogin",
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/PageLogin.vue